import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';

import dayjs from 'dayjs';
import { CONTEXT, STORE_3G_HOST, STORE_3G_CHANNEL } from '../../config';
import { getAAppDetails, showAAppQRCode, getAAppGift } from '../../actions/adetail';
import { setTopImgVideoVisible } from '../../actions/layout';
import { downloadAddSoft } from '../../actions/downloadTask';
import { logging, logPostInfo } from '../../actions/log';
import Loading from '../../components/Loading/Loading';
import { getQueryString } from '../../utils/utils';
import styles from './SoftDetail.module.less';
import SoftDetailMore from './SoftDetailMore';
import SoftDetailSimple from './SoftDetailSimple';
import SoftRecommend from './SoftRecommend';
import SoftDetailSwiper from '../../components/SoftMetaSwiper/SoftMetaSwiper';
import SoftDetailInfos from './SoftDetailInfos';
import SoftDetailGift from './SoftDetailGift';

import DetailScore from '../../components/Detail/DetailScore';
// import CommentScore from '../../components/Comment/CommentScore';
// import CommentList from '../../components/Comment/CommentList';
import { KeepAlive, useActivate, useUnactivate } from 'react-activation';
import TopImgVideo from '../../components/TopImgVideo/TopImgVideo';
import { useInView } from 'react-intersection-observer';
import config from './config';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import Comment from '../../components/Comment/Comment';

const selectAppDetails = createSelector(
  state => state.adetail,
  adetail => adetail.appDetails,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectCommentList = createSelector(
  state => state.comment,
  comment => comment.commentList,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectDetailGift = createSelector(
  state => state.adetail,
  adetail => adetail.detailGift,
);
const selectTopImgVideoVisible = createSelector(
  state => state.layout,
  layout => layout.topImgVideo,
);
const selectForum = createSelector(
  state => state.forum,
  forum => forum,
);

function Adetail(props) {
  const { match } = props;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  // const appDetailsData = useSelector(selectAppDetails); // 详情数据
  const [appDetailsData, setAppDetailsData] = useState(null);
  const commentList = useSelector(selectCommentList); // 只为拿取评分数目
  // const detailGift = useSelector(selectDetailGift); // 只为拿取礼包数
  const [detailGift, setDetailGift] = useState(null);
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const topImgVideo = useSelector(selectTopImgVideoVisible); // 头部图片视频

  const [logFlag, setLogFlag] = useState(false); // 只报一次的桩
  const detailVideo = useRef(null);

  const [showContent, setShowContent] = useState('detail'); // 展示内容
  const [isPlay, setIsPlay] = useState(true); // 视频是否正在播放
  const { forumCommentList } = useSelector(selectForum);
  const node = useRef(null);
  const [videoInfo, setVideoInfo] = useState({ showBtn: false, showSimple: false });
  const loginStatus = useLoginStatus();
  const [releaseInfo, setReleaseInfo] = useState(null);
  const initTime = useRef(Date.now());
  const [isClick, setIsClick] = useState(false); // 判断按钮是否被点击
  const [isVideoShow, setIsVideoShow] = useState(false); // 判断视频是否在可视区域内
  const downloadList = useSelector(selectDownloadSofts);
  const [afferentShow, setAfferentShow] = useState(false); // 是否有传入comment
  const [transmissionScore, setTransmissionScore] = useState(null); // 传入的分数

  const [ref, inView] = useInView({
    threshold: 0,
  });

  /**
   * 统计页面浏览时长
   */
  const handlePvTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `AppDetail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime: initTime.current,
          leaveTime,
          time: leaveTime - initTime.current,
          packageName: match.params.pn,
          versionCode: match.params.vc,
        },
        param3: match.params.bizInfo,
      }),
    );
  }, []);
  useEffect(() => {
    initTime.current = Date.now();
    return () => {
      handlePvTimeLog();
    };
  }, []);
  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
    initTime.current = +new Date();
  });
  useUnactivate(() => {
    handlePvTimeLog();
  });

  const pagePvLog = useCallback(() => {
    // 推荐页面PV打桩  必须设备信息获取成功之后进行
    const param2 = {
      source: 'AppDetail',
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: match.params.pn || '',
      softType: '1',
      packageName: match.params.pn,
      versionCode: match.params.vc,
    };
    // 搜索结果也跳转过来的，带上附加信息
    if (logInfoData.source === 'Search' || logInfoData.source_p === 'Search') {
      param2.search_type = logInfoData.search_type;
      param2.search_word = logInfoData.search_word;
    }
    dispatch(
      logging({
        category: 'P',
        action: 'AppDetail',
        label: '',
        param2: param2,
        bizInfo: match.params.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source: 'AppDetail',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, []);

  useEffect(async () => {
    // 获取软件数据
    try {
      const data = await config.getAAppDetails({
        pn: match.params.pn || '',
        vc: match.params.vc || 0,
        bizInfo: match.params.bizInfo || {},
      });
      setAppDetailsData(data);
    } catch (err) {
      //
    }
  }, [dispatch, match, loginStatus]);

  useEffect(() => {
    // 软件已经下架, 无效软件，后端未知已经下架
    if (
      appDetailsData &&
      appDetailsData.paramPN === match.params.pn &&
      (appDetailsData.status === 500 || appDetailsData.status === -1) &&
      appDetailsData.loading === false
    ) {
      history.replace(`${CONTEXT}/error?sourcePage=ASoftDetail`);
    }
  }, [dispatch, match, appDetailsData]);

  // 获取礼包
  useEffect(async () => {
    try {
      const data = await config.getAAppGift({
        androidType: '1',
        softInfo: match.params.pn || '',
        bizInfo: match.params.bizInfo || {},
      });
      setDetailGift(data);
    } catch (err) {
      //
    }
  }, [match]);

  /**
   * 进入软件页面跳到精选评论位置
   */
  useEffect(() => {
    // 软件数据获取成功处理
    const goComment = getQueryString('goComment');
    if (
      appDetailsData &&
      appDetailsData.softID &&
      match.params.id === appDetailsData.softID &&
      goComment &&
      goComment !== '0'
    ) {
      handleChangeMenu('comment');
      setTimeout(() => {
        const el =
          document.querySelector(`[data-id='${goComment}']`) ||
          document.querySelector(`[id='soft_comment_list_header']`);

        el && el.scrollIntoView({ block: 'center' });
      }, 500);
    }
  }, [dispatch, appDetailsData]);

  /**
   * 进入软件页面并且开始下载, 等待更新列表、静默安装数据获取完成才开始下载
   */
  useEffect(() => {
    // 软件数据获取成功处理
    const isDownload = getQueryString('isDownload');
    const adetailIsDownload = sessionStorage.getItem('adetailIsDownload'); // 用于第一次进入页面就下载软件
    if (
      appDetailsData &&
      appDetailsData.softID &&
      match.params.pn === appDetailsData.paramPN &&
      upgradeSofts &&
      upgradeSofts.length != undefined &&
      (!adetailIsDownload || adetailIsDownload !== appDetailsData.paramPN)
    ) {
      // 如果URL上有isDownload=1, 则下载应用。(如果下载状态有(1,2,3,4,5,6) 则当做已经下载过了的就不再下载)
      const status = parseInt(appDetailsData.status, 10) || 0;
      if (status === 0 && isDownload === '1') {
        downLoadInstallSoft(appDetailsData, match.params.bizInfo, upgradeSofts);
        sessionStorage.setItem('adetailIsDownload', appDetailsData.paramPN);
        setIsClick(true);
      }
    }
  }, [dispatch, appDetailsData, upgradeSofts]);

  // 处理当前应用是否在下载中的问题,在下载中直接滑动到相关推荐
  const onDownloadSoft = useCallback(
    list => {
      for (let i = 0; i < downloadList?.length; i++) {
        if (downloadList?.[i].type === 'apk') {
          if (
            downloadList?.[i]?.apk?.SoftName === appDetailsData?.softName &&
            list?.[i]?.attr.status !== 'err' &&
            list?.[i]?.attr.status !== 'dl' &&
            list?.[i]?.attr.status !== 'pause'
            //
          ) {
            setTimeout(() => {
              const el = document.querySelector(`[id='detail_soft_recommend']`);
              el && el.scrollIntoView({ block: 'center' });
            }, 1000);
          }
        }
      }
    },
    [downloadList, appDetailsData],
  );

  // 8.7需求触发下载滑动到相关推荐 单独处理没有放到button组件里面
  useEffect(() => {
    if (appDetailsData?.cover && appDetailsData?.cover?.showVideo === '1') {
      if (isClick && showContent === 'detail' && isVideoShow && downloadList?.length > 0) {
        onDownloadSoft(downloadList);
        setIsClick(false);
      }
    } else {
      if (isClick && showContent === 'detail' && downloadList?.length > 0) {
        onDownloadSoft(downloadList);
        setIsClick(false);
      }
    }

    // setIsClick(false);
  }, [isClick, showContent, downloadList, isVideoShow, appDetailsData]);

  // 8.7带评分参数进入详情页进行打分
  useEffect(() => {
    // 获取是否打开评分
    let comment = getQueryString('comment');
    let score = getQueryString('score');
    if (location.search) {
      if (comment === '1') {
        setShowContent('comment');
        setAfferentShow(true);
        const el = document.querySelector(`[id='soft_detail_comment']`);
        if (el) {
          const showEl = el.querySelector(`[id='soft_detail_comment_info']`);
          showEl && showEl.scrollIntoView({ block: 'center' });
        }
        // el && el.scrollIntoView({ block: 'center' });
        setTransmissionScore(score);
      }
    }
  }, [location, loginStatus]);

  // 进入详情页面直接下载
  const downLoadInstallSoft = useCallback(
    (softInfo, bizInfo, upgrade_softs) => {
      const upgrade = upgrade_softs.find(
        soft_ =>
          (soft_.androidType !== '1' &&
            (soft_.softID === softInfo.softID || soft_.SoftID === softInfo.softID)) ||
          (soft_.androidType === '1' && soft_.packageName === softInfo.packageName),
      );
      const logParam2 = {
        source: 'AppDetail',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.packageName,
        softName: softInfo.softName,
        packageName: softInfo.packageName,
        versionCode: softInfo.versionCode,
        softType: '1',
        type: upgrade ? 'u' : 'd',
        url: softInfo.downLoadUrl || softInfo.downloadUrl,
      };
      const installSoftInfo = { ...softInfo, logInfo: logParam2, bizInfo };
      dispatch(downloadAddSoft(installSoftInfo));
    },
    [dispatch],
  );

  // 切换详情和评论菜单
  const handleChangeMenu = useCallback(
    menu => {
      if (menu) {
        dispatch(
          logging({
            category: 'C',
            action: 'AppDetail_Tab',
            label: '',
            param2: {
              source: 'AppDetail',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: appDetailsData.softID,
              softType: '1',
              tab: menu,
            },
            param3: appDetailsData.bizInfo,
          }),
        );
        setShowContent(menu || 'detail');
      }
    },
    [appDetailsData],
  );

  /**
   * 点击控制播放音乐
   */
  const onVideoClick = useCallback((play, mute) => {
    if (window.TopVideoPlayPause) {
      window.TopVideoPlayPause(!play, mute);
      setIsPlay(!play);
    }
  });

  // /**
  //  * 已进入页面先取消展示视频，避免有视频
  //  */
  // useEffect(() => {
  //   dispatch(
  //     setTopImgVideoVisible({
  //       visible: false,
  //       isScrolled: false,
  //     }),
  //   );
  // }, [appDetailsData]);

  // /**
  //  * 退出页面时不展示视频
  //  */
  // useEffect(() => {
  //   return () => {
  //     dispatch(
  //       setTopImgVideoVisible({
  //         visible: false,
  //         isScrolled: false,
  //       }),
  //     );
  //   };
  // }, [appDetailsData]);

  // /**
  //  * 处理退回页面，调整显示视频
  //  */
  // useEffect(() => {
  //   if (
  //     appDetailsData &&
  //     appDetailsData.paramPN === match.params.pn &&
  //     appDetailsData.cover &&
  //     history.action === 'POP'
  //   ) {
  //     if (topImgVideo && topImgVideo.visible) {
  //       const imgVideoDom = document.getElementById('img_video_detail');
  //       // 根据进度设置视频的透明度
  //       if (imgVideoDom && imgVideoDom.style) {
  //         imgVideoDom.style.opacity = 1;
  //       }
  //     } else {
  //       dispatch(
  //         setTopImgVideoVisible({
  //           visible: true,
  //           page: 'detail',
  //           data: appDetailsData.cover,
  //         }),
  //       );
  //     }
  //   }
  // }, [match, appDetailsData, topImgVideo]);

  // /**
  //  * 非回退进入详情页面，调整距离显示视频
  //  */
  // useEffect(() => {
  //   if (
  //     appDetailsData &&
  //     appDetailsData.paramPN === match.params.pn &&
  //     appDetailsData.cover &&
  //     history.action !== 'POP'
  //   ) {
  //     setTimeout(() => {
  //       dispatch(
  //         setTopImgVideoVisible({
  //           visible: true,
  //           page: 'detail',
  //           data: appDetailsData.cover,
  //         }),
  //       );
  //       const imgVideoDom = document.getElementById('img_video_detail');
  //       if (imgVideoDom && imgVideoDom.style) {
  //         imgVideoDom.style.opacity = 1;
  //       }
  //     }, 100);
  //   }
  // }, [match, appDetailsData, history]);
  const handelMouseOver = useCallback(e => {
    setVideoInfo(state => ({ ...state, showBtn: e?.clientY <= 329 }));
  }, []);
  const handleScroll = useCallback(e => {
    setVideoInfo(state => ({
      ...state,
      showSimple: +(e?.target?.scrollTop || 0) >= 309,
      scrollTop: +(e?.target?.scrollTop || 0),
    }));
    if (appDetailsData?.cover && appDetailsData?.cover.showVideo === '1') {
      setIsVideoShow(~~e?.target?.scrollTop >= 300);
    }
  }, []);

  if (
    !appDetailsData ||
    !appDetailsData.packageName ||
    match.params.pn !== appDetailsData.packageName
  ) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <>
      <div className={styles.detail_video} ref={detailVideo}>
        {appDetailsData.cover && appDetailsData.cover.showVideo === '1' && inView && (
          <TopImgVideo page="detail" data={appDetailsData.cover} node={node.current} />
        )}
      </div>
      <div
        className={styles.detail}
        ref={node}
        onScroll={handleScroll}
        pagescroll="PCStore_Page_Scroll"
      >
        {/* {appDetailsData.cover && appDetailsData.cover.showVideo === '1' && (
          <div className={styles.detail_video_lay}>
            <div
              className={`${isPlay ? styles.icon_v_play : styles.icon_v_stop} ${
                styles.detail_video_btn
              }`}
              style={{
                display: videoInfo.showBtn ? 'inline-block' : 'none',
                top: `calc(113px - ${videoInfo?.scrollTop}px)`,
              }}
              onClick={e => {
                onVideoClick(isPlay, true);
                e.stopPropagation();
              }}
            />
          </div>
        )} */}

        {appDetailsData.cover && appDetailsData.cover.showVideo === '1' && (
          <div
            className={styles.detail_video_lay}
            onMouseOver={e => {
              setVideoInfo(state => ({ ...state, showBtn: e?.clientY <= 329 }));
            }}
            onMouseLeave={() => {
              setVideoInfo({ ...videoInfo, showBtn: false });
            }}
          >
            <div
              className={`${isPlay ? styles.icon_v_play : styles.icon_v_stop} ${
                styles.detail_video_btn
              }`}
              onClick={e => {
                onVideoClick(isPlay, true);
                e.stopPropagation();
              }}
            />
          </div>
        )}

        <div className={styles.detail_box}>
          <div
            className={styles.detail_more}
            style={{
              opacity: inView ? 1 : 0,
              // top: videoInfo?.showSimple ? '-20px' : '0px',
            }}
            ref={ref}
          >
            <SoftDetailMore
              softDetails={appDetailsData}
              match={match}
              updateSoftDetails={data => setAppDetailsData(data)}
              handleDowm={e => setIsClick(e)}
            />
          </div>
          {!inView && (
            <div className={styles.detail_simple} style={{ opacity: !inView ? 1 : 0 }}>
              <SoftDetailSimple
                softDetails={appDetailsData}
                match={match}
                updateSoftDetails={data => setAppDetailsData(data)}
              />
            </div>
          )}
          <div
            className={styles.detail_menu}
            style={inView ? { position: 'relative', top: 0 } : {}}
          >
            <div
              className={showContent === 'detail' ? 'detail_menu_item_active' : 'detail_menu_item'}
              onMouseOver={() => {
                handleChangeMenu('detail');
              }}
              onFocus={() => undefined}
            >
              详情
            </div>
            <div
              className={showContent === 'comment' ? 'detail_menu_item_active' : 'detail_menu_item'}
              onMouseOver={() => {
                handleChangeMenu('comment');
              }}
              onFocus={() => undefined}
            >
              评论
              {releaseInfo?.commentNum > 0 ? `(${releaseInfo?.commentNum})` : ''}
            </div>
            {detailGift &&
              detailGift.softInfo === match.params.pn &&
              detailGift.dataList &&
              detailGift.dataList.length > 0 && (
                <div
                  className={
                    showContent === 'gift' ? 'detail_menu_item_active' : 'detail_menu_item'
                  }
                  onMouseOver={() => {
                    handleChangeMenu('gift');
                  }}
                  onFocus={() => undefined}
                >
                  <span className="menu_gift" />
                  礼包
                </div>
              )}
          </div>
          <div
            className={styles.detail_content}
            style={{ display: showContent === 'detail' ? 'flex' : 'none' }}
          >
            <div className={styles.detail_pic_view}>
              <SoftDetailSwiper
                swiperData={appDetailsData.captureFileList}
                appInfo={appDetailsData}
              />
            </div>
            <SoftDetailInfos appDetailsData={appDetailsData} />
            <div className={styles.detail_recommend}>
              <SoftRecommend softDetails={appDetailsData} />
            </div>
          </div>
          <div
            className={styles.detail_comment}
            style={{ display: showContent === 'comment' ? 'flex' : 'none' }}
          >
            {/* <DetailScore appDetailsData={appDetailsData} /> */}
            {/* 评论类型  1-应用评论  2-专题评论  3-帖子评论 */}
            <Comment
              data={{
                type: '1',
                bizIdentity: appDetailsData?.packageName,
                tagCode: appDetailsData?.classID,
              }}
              scrollEl={node.current}
              handleReleaseInfo={data => {
                setReleaseInfo(data);
              }}
              commentTargetInfo={{
                targetId: appDetailsData?.packageName,
                targetName: appDetailsData?.softName,
                targetCategoryCode: [appDetailsData?.classID],
                version: appDetailsData?.version,
              }}
              afferentShow={afferentShow}
              transmissionScore={transmissionScore}
              emptyIsOpen={() => setTransmissionScore(null)}
              isScoreEmpty={true}
            />
            {/* 
          <CommentScore
            appDetailsData={appDetailsData}
            type={1}
            commentId={appDetailsData.packageName}
            relaseId={appDetailsData.packageName}
            logInfo={{ source: 'AppDetail' }}
          />
          <CommentList
            type={1}
            commentId={appDetailsData.packageName}
            relaseId={appDetailsData.packageName}
            hasScore
            logInfo={{ source: 'AppDetail' }}
          /> */}
          </div>
          {detailGift &&
            detailGift.softInfo === match.params.pn &&
            detailGift.dataList &&
            detailGift.dataList.length > 0 && (
              <div
                className={styles.detail_gift}
                style={{ display: showContent === 'gift' ? 'flex' : 'none' }}
              >
                <SoftDetailGift props={props} appDetailsData={appDetailsData} />
                <div className={styles.detail_recommend}>
                  <SoftRecommend softDetails={appDetailsData} />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
}

export default memo(props => {
  return (
    <KeepAlive name="adetail" id={props?.match?.params?.pn}>
      <Adetail {...props} />
    </KeepAlive>
  );
});
